import { Injectable, inject } from '@angular/core';
import {
  ConnectProviderRequestDTO,
  LogisticsProviderAccountDTO,
  LogisticsProviderControllerService,
  LogisticsProviderPageRequestDTO,
  PageInfoLogisticsProviderAccountDTO,
} from '@app/api/after-sales-service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CarrierService {
  private apiService = inject(LogisticsProviderControllerService);

  searchCarriers(
    payload: LogisticsProviderPageRequestDTO
  ): Observable<PageInfoLogisticsProviderAccountDTO> {
    const normalizedPayload: LogisticsProviderPageRequestDTO = {
      ...payload,
      status: payload.status?.trim() || undefined,
      providerCode: payload.providerCode?.trim() || undefined,
      providerName: payload.providerName?.trim() || undefined,
      code: payload.code?.trim() || undefined,
      name: payload.name?.trim() || undefined,
      description: payload.description?.trim() || undefined,
    };
    return this.apiService.page(normalizedPayload, undefined, undefined, {
      httpHeaderAccept: 'application/json' as any,
    });
  }

  checkHealthAccount(id: number): Observable<string> {
    return this.apiService.checkHealthAccount(id, undefined, undefined, {
      httpHeaderAccept: 'application/json' as any,
    });
  }

  getCarrierById(
    id: number | null | undefined
  ): Observable<LogisticsProviderAccountDTO> {
    return this.apiService.detailAccount(id as number, undefined, undefined, {
      httpHeaderAccept: 'application/json' as any,
    });
  }

  createCarrier(
    payload: ConnectProviderRequestDTO
  ): Observable<LogisticsProviderAccountDTO> {
    return this.apiService.connectAccount(payload, undefined, undefined, {
      httpHeaderAccept: 'application/json' as any,
    });
  }

  updateCarrier(
    id: number | null | undefined,
    payload: Partial<ConnectProviderRequestDTO>
  ): Observable<LogisticsProviderAccountDTO> {
    return this.apiService.updateAccount(
      id as number,
      payload as any,
      undefined,
      undefined,
      {
        httpHeaderAccept: 'application/json' as any,
      }
    );
  }

  deleteCarrier(id: number | null | undefined): Observable<string> {
    if (!id) return of('Fail to delete');
    return this.apiService.batchDelete([id], undefined, undefined, {
      httpHeaderAccept: 'text/plain' as any,
    });
  }
}

